import { ActionContext } from 'vuex';
import { State } from '@/store/state';
import apiService from '@/services/ApiService';
import { countDiffChanges } from '@/store/helpers/diffHelpers';

interface FetchDiffPayload {
  workspaceShortId: string;
  articleShortId: string;
  fromVersion: number;
}

export const diffActions = {
  async fetchDiff(
    { commit, state }: ActionContext<State, State>,
    { workspaceShortId, articleShortId, fromVersion }: FetchDiffPayload
  ) {
    const response = await apiService.article.getDiff(workspaceShortId, articleShortId, fromVersion);
    const diffTabs = response.data.diffTabs;
    const counts = countDiffChanges(diffTabs);

    commit('setDiffState', {
      tabs: diffTabs,
      insertCount: counts.insertCount,
      deleteCount: counts.deleteCount,
      fromVersion,
      articleId: state.workspaceView.selectedArticle.id,
    });
  },
};
